import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    key: Yup.string().required("Key is required"),
    value: Yup.string().required("Value is required")
});